export default __webpack_public_path__ + "static/media/defaultAvatar.c17822ef.svg";